var _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSafetySmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6144 55.884C48.9348 54.6304 61.9475 48.384 62.5234 27.3241C62.5479 26.4269 62.0798 25.579 61.3177 25.1048C51.2347 18.8309 38.4628 18.8309 28.3797 25.1048C27.6176 25.579 27.1495 26.4269 27.174 27.3241C27.7499 48.384 40.7626 54.6304 44.083 55.884C44.5788 56.0712 45.1186 56.0712 45.6144 55.884Z",
    fill: "url(#paint0_linear_2323_17103)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2323_17103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2908 32.4822L25.691 33.3964C24.7721 33.9215 24.1983 34.9124 24.2332 35.9701C24.9866 58.7998 40.6303 65.2972 44.1497 66.4724C44.6125 66.627 45.0846 66.627 45.5475 66.4724C49.0669 65.2972 64.7105 58.7998 65.4639 35.9701C65.4988 34.9124 64.925 33.9214 64.0061 33.3964L62.4063 32.4822C51.5266 26.2653 38.1705 26.2653 27.2908 32.4822Z",
    fill: "#6AE092",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7637 33.5237L27.3635 32.6095C38.1981 26.4183 51.499 26.4183 62.3336 32.6095L63.9334 33.5237C64.8068 34.0228 65.3504 34.9638 65.3173 35.9653C64.9419 47.3435 60.8574 54.6409 56.4372 59.2401C52.0142 63.8422 47.2472 65.7502 45.501 66.3334C45.0683 66.4779 44.6288 66.4779 44.1961 66.3334C42.4499 65.7502 37.683 63.8422 33.2599 59.2401C28.8397 54.6409 24.7552 47.3435 24.3798 35.9653C24.3467 34.9638 24.8903 34.0228 25.7637 33.5237Z",
    stroke: "url(#paint1_linear_2323_17103)",
    strokeWidth: 0.293236
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2907 48.8967C43.3127 48.9187 43.3425 48.9311 43.3736 48.9311C43.4047 48.9311 43.4346 48.9187 43.4565 48.8967L52.2143 40.139C53.0323 39.321 54.3584 39.321 55.1764 40.139C55.9943 40.9569 55.9943 42.2831 55.1764 43.101L44.8546 53.4228C44.4619 53.8156 43.9291 54.0362 43.3736 54.0362C42.8181 54.0362 42.2854 53.8156 41.8926 53.4228L35.9944 47.5246C35.1765 46.7067 35.1765 45.3805 35.9944 44.5626C36.8124 43.7446 38.1386 43.7446 38.9565 44.5626L43.2907 48.8967Z",
    fill: "url(#paint2_linear_2323_17103)",
    fillOpacity: 0.9,
    stroke: "url(#paint3_linear_2323_17103)",
    strokeWidth: 0.234589,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2323_17103",
    x: 18.3343,
    y: 21.9222,
    width: 53.0287,
    height: 50.5638,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.94907
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2323_17103"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2323_17103",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2323_17103",
    x1: 35.0249,
    y1: 29.5283,
    x2: 73.4796,
    y2: 58.4698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75EDA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#349256"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2323_17103",
    x1: 25.0012,
    y1: 31.8328,
    x2: 76.1852,
    y2: 69.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2323_17103",
    x1: 38.4897,
    y1: 45.0302,
    x2: 70.7457,
    y2: 48.8423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2323_17103",
    x1: 35.8506,
    y1: 41.5114,
    x2: 49.0462,
    y2: 45.9099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSafetySmall);
export default __webpack_public_path__ + "static/media/icon-safety-small.d07e7921551dc8706d477a5aaac1afa6.svg";
export { ForwardRef as ReactComponent };